import React from 'react'
import { Form, MagicInput, Popconfirm, Space } from 'hljd'
import styles from './index.module.less'
import MinusCircleOutlined from '@ant-design/icons/lib/icons/MinusCircleOutlined'

/**
 * @author  Ta_Mu
 * @date  2020/12/11 10:24
 */
const DiscountItem = ({onRemove, field}) => {

  return (
    <Space align='center' className={styles.container}>
      <Form.Item
        {...field}
        rules={[{ required: true, message: '最少输入3个字'}, {min: 3, message: '最少输入3个字'}]}
      >
        <MagicInput
          maxLength={15}
          size="middle"
          showCount
          countPosition="inner"
          placeholder="请输入优惠信息"
          style={{ width: 400}}
        />
      </Form.Item>
      <Form.Item style={{width: 200, marginLeft: 8}} shouldUpdate={(prevValues, curValues) => prevValues['names'][field.name] !== curValues['names'][field.name]}>
        {
          (form) => {
            if(form.getFieldValue(['names', field.name])?.length > 0) {
              return (
                <Popconfirm title='确定要删除这条优惠信息吗？' onConfirm={onRemove}>
                  <MinusCircleOutlined className={styles.minusIcon}/>
                </Popconfirm>
              )
            }
            return <MinusCircleOutlined  className={styles.minusIcon} onClick={onRemove}/>
          }
        }
      </Form.Item>
    </Space>
  )
}

export default DiscountItem
